import React from 'react';
import { useTranslation } from 'react-i18next';
import { AvailablePopups } from 'store/app/types';
import Popup from 'components/Common/Popup/Popup';
import ItemsFilter from '../Sidebar/ItemsFilter/ItemsFilter';
import SortBy from './SortBy/SortBy';
import styles from './FilterMobilePopup.module.scss';

const FilterMobilePopup = () => {
  const { t } = useTranslation();
  return (
    <Popup popupId={AvailablePopups.filterMobilePopup} title={t('txt_filters')} applyButtonTitle={t('txt_close')}>
      <div className={styles.filterMobile}>
        <SortBy />
        <ItemsFilter />
      </div>
    </Popup>
  );
};

export default FilterMobilePopup;
